import React from 'react';
import styles from './AirdropSection.module.css';
import {useTranslation} from "react-i18next";

const AirdropSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.airdropSection}>
      <div className={styles.airdropContent}>
        <h1 className={styles.title}>{t('getPell')}</h1>
        <span className={styles.description}>
          {t('enroll')}
        </span>
        <p className={styles.deadline}>
          {t('joinWhiteList')} <span className={styles.date}>{t('joinDate')}</span>
        </p>
      </div>
      <div className={styles.statsContainer}>
        <div className={styles.statCard}>
          <span className={styles.statTitle}>{t('participants')}</span>
          <span className={styles.statValue}>165,980</span>
        </div>
        <div className={styles.statCard}>
          <span className={styles.statTitle}>{t('total')}</span>
          <span className={styles.statValue}>50,000,000</span>
        </div>
      </div>
    </section>
  );
};

export default AirdropSection;